import React, { useState } from "react";
import { Grid, Typography, makeStyles, Box } from "@material-ui/core";

import { ShaDowBox } from "../../../../../components/boxes";
import { Icon } from "../../../../../components/base";
import SelectBox from "../../../../../components/SelectBox";
import { COLORS } from "../../../../../theme/colors";
import { useMemo } from "react";

const useStyle = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    padding: 20
  },
  innerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  leftContainer: {
    width: "100%",
    marginLeft: 20
  },
  docName: {
    fontSize: 14,
    color: COLORS.darks[0][100],
    marginBottom: 5
  },
  docdet: {
    fontSize: 12,
    color: COLORS.darks[0][100],
    marginBottom: 5
  },
  downContainer: {
    marginRight: 15
  },
  shortnameContainer: {
    height: 50,
    width: 50,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  selectContainer: {
    borderRadius: 5,
    "& .MuiInputBase-input": {
      padding: "0px 4px"
    }
  },
  selectRoot: {
    color: COLORS.white
  }
}));

function UsersCard({
  shortName,
  icon,
  email,
  name,
  deleteIcon,
  xs,
  style,
  options,
  handleDeleteUser,
  userId,
  changeUserRole
}) {
  const classes = useStyle();
  const [value, setValue] = useState("Admin");

  const handleChangeUserRole = (role) => {
    changeUserRole(userId, role.toUpperCase());
    setValue(role);
  };

  const handleSelectedRole = useMemo(
    (val) => {
      switch (val) {
        case "operator":
          return "#6200EE";
        case "basic":
          return "#6EC1CB";
        default:
          return "#6200EE";
      }
    },
    [value]
  );

  return (
    <Grid xs={xs} style={{ marginTop: "20px" }}>
      <ShaDowBox>
        <Box className={classes.container} container style={style}>
          <Box className={classes.innerContainer}>
            {icon ? (
              <Icon src={icon} />
            ) : (
              <Box
                style={{
                  backgroundColor: COLORS.darks[0][6]
                }}
                className={classes.shortnameContainer}
              >
                <Typography style={{ color: handleSelectedRole }}>
                  {shortName}
                </Typography>
              </Box>
            )}
          </Box>
          <Box className={classes.leftContainer}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                xs={9}
              >
                <Grid item xs={5}>
                  <Typography className={classes.docName}>{name}</Typography>
                </Grid>
                <Grid item>
                  <Box
                    className={classes.selectContainer}
                    style={
                      value == "operator"
                        ? { backgroundColor: "#6200EE" }
                        : value == "basic"
                        ? { backgroundColor: "#6EC1CB" }
                        : { backgroundColor: "#FF952B" }
                    }
                  >
                    <SelectBox
                      options={options}
                      setValue={handleChangeUserRole}
                      value={value}
                      defaultValue={value}
                      selectRoots={classes.selectRoot}
                      containerStyle={{ color: "#FFFFFF", width: "100px" }}
                    />
                  </Box>
                </Grid>
              </Grid>

              <Grid item xs={1}>
                <Box className={classes.downContainer}>
                  {deleteIcon && (
                    <Icon
                      src={deleteIcon}
                      onClick={() => handleDeleteUser(userId)}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
            <Box className={classes.docContent}>
              <Box>
                <Typography className={classes.docdet}>{email}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </ShaDowBox>
    </Grid>
  );
}

export default UsersCard;
